import React from 'react';
import { Box, Typography, Button, Container } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { themeColors } from '../styles/theme';

const NotFound: React.FC = () => {
  const navigate = useNavigate();

  return (
    <Container maxWidth="sm">
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '80vh',
          textAlign: 'center',
          p: 3,
        }}
      >
        <Typography
          variant="h1"
          sx={{
            fontSize: '8rem',
            fontWeight: 700,
            color: themeColors.orange,
            lineHeight: 1,
            mb: 2,
          }}
        >
          404
        </Typography>
        <Typography
          variant="h4"
          sx={{
            color: themeColors.darkBackground,
            mb: 3,
            fontWeight: 600,
          }}
        >
          Oops! Page Not Found
        </Typography>
        <Typography
          variant="body1"
          sx={{
            color: 'rgba(34, 34, 34, 0.7)',
            mb: 4,
            maxWidth: '400px',
          }}
        >
          The page you're looking for doesn't exist or has been moved. Let's get you back on track!
        </Typography>
        <Button
          variant="contained"
          onClick={() => navigate('/')}
          sx={{
            backgroundColor: themeColors.orange,
            '&:hover': {
              backgroundColor: themeColors.mainYellow,
            },
            px: 4,
            py: 1.5,
            borderRadius: 2,
            textTransform: 'none',
            fontSize: '1.1rem',
          }}
        >
          Return Home
        </Button>
      </Box>
    </Container>
  );
};

export default NotFound; 